import React from "react";

import ErrorPage from "@/components/error-page";
import DocumentSearch from "@/components/icons/document-search.svg";

const Custom404: React.VoidFunctionComponent = () => {
  return (
    <ErrorPage
      icon={DocumentSearch}
      title="404 nichts gefunden"
      description="Tut mir leid, hier ist nichts."
    />
  );
};

export default Custom404;
